// removed by extract-text-webpack-plugin
module.exports = {"FriendBox":"FriendBox__FriendBox__2aa_X","Field":"FriendBox__Field__3PbQY","ActiveCheckbox":"FriendBox__ActiveCheckbox__1T2HT","Settings":"FriendBox__Settings__1-rdC","CancelButton":"FriendBox__CancelButton__1mkaL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FriendBox/FriendBox.css
// module id = 780
// module chunks = 0